import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../utils';
const colors = {
    gray: 'text-gray-500 bg-gray-400/30',
    red: 'text-red-400 bg-red-400/30',
    yellow: 'text-yellow-400 bg-yellow-400/30',
    green: 'text-green-400 bg-green-400/30',
    blue: 'text-blue-400 bg-blue-400/30',
    rose: 'text-rose-400 bg-rose-400/30',
};
export default function DotStatus({ color = 'green', animate }) {
    return (_jsxs("div", { className: "relative h-fit flex-none p-1", children: [animate && (_jsx("div", { className: classNames(colors[color], 'absolute inset-0 rounded-full', 'animate-ping duration-700') })), _jsx("div", { className: classNames(colors[color], 'h-1.5 w-1.5 rounded-full bg-current') })] }));
}
